/// <reference types="google.maps" />
import { CommonModule } from '@angular/common';
import { Component, Inject, Input, OnInit } from '@angular/core';
import { GoogleMap, MapAdvancedMarker } from '@angular/google-maps';

import { EnvironmentInterface } from '../../types';

@Component({
    selector: 'lib-google-map-location',
    standalone: true,
    imports: [CommonModule, GoogleMap, MapAdvancedMarker],
    templateUrl: './google-map-location.component.html',
    styleUrl: './google-map-location.component.css'
})
export class GoogleMapLocationComponent implements OnInit {
    @Input({ required: true }) latitude: number | undefined = undefined;
    @Input({ required: true }) longitude: number | undefined = undefined;
    @Input() height: string | undefined = '210px';
    @Input() zoom: number = 12;

    markerSvg = `<svg width="49" height="49" viewBox="0 0 49 49" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="0.513672" y="0.0395508" width="48" height="48" rx="24" fill="#F56F10" fill-opacity="0.1"/><circle cx="24.5137" cy="24.0396" r="8" fill="#F56F10"/></svg>`;

    //Map styles are set through the Google Cloud dashboard under "Map styles" and are assigned to a Map Id under "Map management"
    options: google.maps.MapOptions = {
        zoom: 12,
        minZoom: 10,
        maxZoom: 15,
        clickableIcons: false,
        disableDefaultUI: true,
        fullscreenControl: false
    };

    center: google.maps.LatLngLiteral | google.maps.LatLng | null = {
        lat: 0,
        lng: 0
    };

    markerContent: HTMLElement | null = null;

    mapId: string = '';

    constructor(@Inject('environment') environment: EnvironmentInterface) {
        this.mapId = environment.googleMapsId;
    }

    ngOnInit(): void {
        const parser = new DOMParser();
        const svgString = this.markerSvg;

        this.markerContent = parser.parseFromString(svgString, 'image/svg+xml').documentElement;

        this.center = {
            lat: this.latitude || 0,
            lng: this.longitude || 0
        };

        this.options.zoom = this.zoom;
    }
}
